/**
 * Sprint 0.23 — Standardprofile-Registry.
 */

import efhNeubauStandard from "./efh-neubau-standard.js";
import efhNeubauGehoben from "./efh-neubau-gehoben.js";
import efhSanierungStandard from "./efh-sanierung-standard.js";
import type { Standardprofil } from "./types.js";

export type { Standardprofil, StandardprofilGewerkKriterien } from "./types.js";

export const STANDARDPROFILE: Standardprofil[] = [
  efhNeubauStandard,
  efhNeubauGehoben,
  efhSanierungStandard,
];

const byId = new Map<string, Standardprofil>(
  STANDARDPROFILE.map((p) => [p.id, p])
);

export function getStandardprofil(id: string): Standardprofil | undefined {
  return byId.get(id);
}

export function getDefaultStandardprofilId(
  projektart: "Neubau" | "Sanierung",
  qualitaetsstandard: "Basis" | "Standard" | "Gehoben" | "Premium"
): string {
  for (const p of STANDARDPROFILE) {
    if (p.projektart !== "any" && p.projektart !== projektart) continue;
    if (p.qualitaetsstandard.includes(qualitaetsstandard)) return p.id;
  }
  // Fallback
  return projektart === "Sanierung"
    ? "efh-sanierung-standard"
    : "efh-neubau-standard";
}
